/**
 * Base "resource"; doesn't know about where its data comes from
 * (e.g. API calls or in-memory models), but handles common logic
 * like subscription management.
 */

export enum ModelStatus {
  /** Object exists, but has never attempted to be populated */
  Idle = `Idle`,
  /** Getting value from an async source */
  Loading = `Loading`,
  /** Value has successfully been loaded */
  Success = `Success`,
  /** Failed to get the value */
  Error = `Error`,
  /** Async fetch succeeded but no object was found */
  NotFound = `NotFound`,
}

/** Model success status should always have a value */
type ModelSuccess<ModelT> = {
  status: ModelStatus.Success;
  value: ModelT;
  error?: Error | string;
};

type ModelOther<ModelT> = {
  status: Exclude<ModelStatus, ModelStatus.Success>;
  value?: ModelT;
  error?: Error | string;
};

/**
 * A single model instance, with metadata about its lifecycle
 * (loading, ready to use, errored out while loading)
 */
export type Model<ModelT> = ModelSuccess<ModelT> | ModelOther<ModelT>;
